import { SubscriptionPlan, SubscriptionPlanName } from "@arelia-types/subscriptions";

export const displayPlanName = (plan: SubscriptionPlan, isFreePlan?: boolean) => {
  if (plan === SubscriptionPlanName.Free || plan === SubscriptionPlanName.Starter) {
    return `${plan} plan`;
  }

  let baseName: string;

  switch (plan) {
    case SubscriptionPlanName.MySocialMyFans:
      baseName = "My Social + My Fans";
      break;
    case SubscriptionPlanName.MySocial:
      baseName = "My Social";
      break;
    default:
      baseName = `${plan} plan`;
      break;
  }

  return isFreePlan ? `Free ${baseName}` : baseName;
};
